"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageWrapper = exports.MainWrapper = exports.HeaderWrapper = exports.ContentWrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styles = require("../../shared/styles");
var PageWrapper = exports.PageWrapper = _styledComponents.default.div.withConfig({
  displayName: "Containersstyled__PageWrapper",
  componentId: "sc-mtbo1q-0"
})(["display:flex;flex-direction:column;flex:1 1 auto;height:100%;width:100%;"]);
var HeaderWrapper = exports.HeaderWrapper = _styledComponents.default.div.withConfig({
  displayName: "Containersstyled__HeaderWrapper",
  componentId: "sc-mtbo1q-1"
})(["display:flex;padding:", " ", " 0px ", ";background:", ";border-bottom:1px solid ", ";"], _styles.spacing.l, _styles.spacing.xl, _styles.spacing.xl, _styles.colors.background.primary, _styles.colors.border.primary.default);
var MainWrapper = exports.MainWrapper = _styledComponents.default.div.withConfig({
  displayName: "Containersstyled__MainWrapper",
  componentId: "sc-mtbo1q-2"
})(["display:flex;flex-direction:column;flex:1 1 auto;height:100%;width:100%;gap:", ";padding:", ";"], _styles.spacing.xl, _styles.spacing.xl);
var ContentWrapper = exports.ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "Containersstyled__ContentWrapper",
  componentId: "sc-mtbo1q-3"
})(["display:flex;justify-content:space-between;gap:", ";flex:0 1 auto;width:", ";", " border:1px solid ", ";border-radius:", ";padding:", ";"], _styles.spacing.m, function (_ref) {
  var width = _ref.width;
  return width ? width : '440px';
}, function (_ref2) {
  var height = _ref2.height;
  return (0, _styledComponents.css)(["height:", ";"], height);
}, _styles.colors.border.primary.default, _styles.borderRadius.s, function (_ref3) {
  var padding = _ref3.padding;
  return padding ? padding : _styles.spacing.l;
});